import QR from "qrcode-base64";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import imgPPLogo from "../../../assets/img/pp-logo-black.png";
import { formatCurrency, getDateTime } from "../../../utils/format";
import { interRegular } from "../../../assets/font/base64/Inter";
import { interSemiBold } from "../../../assets/font/base64/Inter-SemiBold";

const PAGE_HALF_WIDTH = 74.25;
const PAGE_WIDTH = 148.5;
let COLUMN_GAP = 8;

const TBL_HEADER_STYLE = {
  fillColor: [255, 255, 255],
  textColor: [0, 0, 0],
  lineWidth: { left: 0, right: 0, bottom: 0.1 },
  lineColor: [0, 0, 0],
  font: "Times-New-Roman-Bold",
};

const TBL_BODY_STYLE = {
  fillColor: [255, 255, 255],
  textColor: [0, 0, 0],
  lineWidth: { left: 0, right: 0, bottom: 0.1 },
  // lineColor: [0, 0, 0],
};

export const printDeliverySlipPDF = (slips = {}) => {
  const doc = new jsPDF({ format: "a5", compress: true });
  doc.addFileToVFS("Times-New-Roman.ttf", interRegular);
  doc.addFont("Times-New-Roman.ttf", "Times-New-Roman", "normal");
  doc.addFileToVFS("Times-New-Roman-Bold.ttf", interSemiBold);
  doc.addFont("Times-New-Roman-Bold.ttf", "Times-New-Roman-Bold", "normal");

  for (let i = 0; i < slips.length; i++) {
    const data = slips[i];
    drawSlip({ doc, data });
    if (i + 1 !== slips.length) doc.addPage();
  }

  const pdfData = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfData);
  var printWindow = window.open(pdfUrl, "_blank");
  printWindow.onload = function () {
    printWindow.print();
    URL.revokeObjectURL(pdfUrl);
  };
};

const drawSlip = ({ doc, data }) => {
  const qrBase64 = QR.drawImg(data?.code ?? "");
  const products = data.children?.map((item) => {
    return [
      // item?.productSKU || "-",
      item?.barcodes?.join(", "),
      item?.requesterCode ?? "",
      item?.productTitle || "-",
      item?.totalPrice
        ? `${formatCurrency(parseInt(item?.totalPrice / item?.totalUnit))}`
        : "-",
      item?.totalUnit || "-",
      item?.totalPrice ? `${formatCurrency(item?.totalPrice)}` : "-",
    ];
  });

  const collectiveProducts = [];
  if (data?.collectiveProducts?.length > 0) {
    data.collectiveProducts.forEach((item) => {
      collectiveProducts.push([
        // item?.productSKU || "-",
        item?.barcodes?.join(", "),
        item?.requesterCode || "-",
        item?.title || "-",
        item?.totalPrice
          ? `${formatCurrency(parseInt(item?.totalPrice / item?.unit))}`
          : "-",
        item?.unit || "-",
        item?.totalPrice ? `${formatCurrency(item?.totalPrice)}` : "-",
      ]);
      if (item?.groupProducts?.length > 0) {
        item.groupProducts.forEach((groupProduct) => {
          collectiveProducts.push([
            "-",
            groupProduct?.requesterCode || "-",
            groupProduct?.title || "-",
            "-",
            "-",
            "-",
          ]);
        });
      }
    });
  }

  const totalPrice = data?.children?.reduce(
    (sum, row) => (sum += row?.totalPrice || 0),
    0
  );
  const totalPriceCollective = data?.collectiveProducts?.reduce(
    (sum, row) => (sum += row?.totalPrice || 0),
    0
  );

  const totalProductUnit = data?.children?.reduce(
    (sum, row) => (sum += row?.totalUnit || 0),
    0
  );
  const totalProductUnitCollective = data?.collectiveProducts?.reduce(
    (sum, row) => (sum += row?.unit || 0),
    0
  );

  const offsetY = 3.797777777777778; //var offsetY is for spacing
  const lineHeight = 4.49111111111111; //var lineHeight is for Spacing
  const leftX = 10;
  let currentY = 10;
  let currentX = leftX;

  doc.setFont("Times-New-Roman");
  doc.setFontSize(8);

  let txt = "Хүлээн авагчийн нэр";
  doc.text(txt, leftX, currentY);
  currentX += doc.getTextWidth(txt);
  doc.setFont("Times-New-Roman-Bold");
  const maxWidth = 32;
  const customerName = data?.customerName || "-";
  const wrappedText = doc.splitTextToSize(customerName, maxWidth);
  doc.text(wrappedText, leftX, currentY + lineHeight);

  doc.setFont("Times-New-Roman");
  doc.text("Утас", leftX, currentY + lineHeight * 2 + offsetY);
  doc.setFont("Times-New-Roman-Bold");
  doc.text(
    data?.customerPhone || "-",
    leftX,
    currentY + lineHeight * 3 + offsetY
  );

  if (data.isReplace) {
    doc.setFont("Times-New-Roman");
    doc.text("Буцаалтын захиалга", leftX, currentY + lineHeight * 4 + offsetY);
    doc.setFont("Times-New-Roman-Bold");
    doc.text(
      data?.replaceOrder || "-",
      leftX,
      currentY + lineHeight * 5 + offsetY
    );
  }

  doc.setFont("Times-New-Roman");
  txt = "Захиалгын дугаар";
  doc.text(txt, currentX + COLUMN_GAP, currentY);
  doc.setFont("Times-New-Roman-Bold");
  doc.text(data?.code || "-", currentX + COLUMN_GAP, currentY + lineHeight);

  doc.setFont("Times-New-Roman");
  doc.text(
    "Захиалсан",
    currentX + COLUMN_GAP,
    currentY + lineHeight * 2 + offsetY
  );
  doc.setFont("Times-New-Roman-Bold");
  doc.text(
    doc.splitTextToSize(
      data?.createdAt ? getDateTime(data.createdAt) : "-",
      25
    ),
    currentX + COLUMN_GAP,
    currentY + lineHeight * 3 + offsetY
  );

  currentX += COLUMN_GAP + doc.getTextWidth(txt) - 2;
  doc.setFont("Times-New-Roman");
  doc.text("Хот, дүүрэг", currentX + COLUMN_GAP, currentY);
  doc.setFont("Times-New-Roman-Bold");
  txt =
    data?.dropoffAddressArray?.length > 2
      ? `${data.dropoffAddressArray[0]?.name}, ${data.dropoffAddressArray[1]?.name}`
      : "-";
  doc.text(
    doc.splitTextToSize(txt, 40),
    currentX + COLUMN_GAP,
    currentY + lineHeight
  );

  let img = new Image();
  img.src = imgPPLogo;
  doc.addImage(img, "png", PAGE_WIDTH - leftX - 20, 7, 20, 5.12, "FAST");

  doc.setFont("Times-New-Roman");
  doc.text(
    "Хороо/Баг",
    currentX + COLUMN_GAP,
    currentY + lineHeight * 2 + offsetY
  );
  doc.setFont("Times-New-Roman-Bold");
  txt =
    data?.dropoffAddressArray?.length > 2
      ? `${data.dropoffAddressArray[2]?.name}`
      : "-";
  doc.text(txt, currentX + COLUMN_GAP, currentY + lineHeight * 3 + offsetY);

  doc.setFont("Times-New-Roman");
  doc.text("Хаяг", currentX + COLUMN_GAP, currentY + lineHeight * 4 + offsetY);
  doc.setFont("Times-New-Roman-Bold");
  doc.text(
    doc.splitTextToSize(data?.dropoffDetail || "-", 60),
    currentX + COLUMN_GAP,
    currentY + lineHeight * 5 + offsetY
  );

  const tblProducts = [...collectiveProducts, ...(products ?? [])];
  autoTable(doc, {
    theme: "grid",
    styles: { font: "Times-New-Roman", fontSize: 8 },
    startY: currentY + lineHeight * 7 + offsetY,
    tableWidth: PAGE_WIDTH - leftX * 2,
    margin: leftX,
    head: [
      [
        "Баркод",
        { content: "Мерчант код", styles: { cellWidth: 18 } },
        { content: "Барааны нэр", styles: { cellWidth: 30 } },
        { content: "Нэгж үнэ", styles: { cellWidth: 22 } },
        { content: "Тоо/Ш", styles: { cellWidth: 12 } },
        { content: "Дүн", styles: { cellWidth: 22 } },
      ],
    ],
    body: tblProducts,
    headStyles: TBL_HEADER_STYLE,
    bodyStyles: {
      ...TBL_BODY_STYLE,
      // textColor: [174, 131, 90],
      // cellWidth: 60,
    },
  });

  currentY = doc.lastAutoTable.finalY;

  if (doc.lastAutoTable.finalY > 180) {
    doc.addPage();
    currentY = 10;
  }

  doc.setFontSize(8);

  doc.setFont("Times-New-Roman");
  doc.text("Нийт тоо/ш:", PAGE_WIDTH - 52 - leftX, currentY + offsetY);
  doc.text(
    `${(totalProductUnit ?? 0) + (totalProductUnitCollective ?? 0)}`,
    PAGE_WIDTH - 32.5 - leftX,
    currentY + offsetY
  );

  doc.setFont("Times-New-Roman-Bold");
  doc.text("Нэмэлт мэдээлэл", leftX + 1.5, currentY + offsetY);
  doc.setFont("Times-New-Roman");
  doc.text(
    doc.splitTextToSize(data?.orderDescription || "-", 25),
    leftX + 1.5,
    currentY + offsetY + lineHeight
  );

  doc.setFont("Times-New-Roman-Bold");
  doc.text("Анхаарах шаардлагатай зүйлс", leftX + 30, currentY + offsetY);
  doc.setFont("Times-New-Roman");
  doc.text(
    doc.splitTextToSize(data?.notes?.join(", ") || "-", 35),
    // doc.splitTextToSize('Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry', 35),
    leftX + 30,
    currentY + offsetY + lineHeight
  );

  doc.setFont("Times-New-Roman-Bold");
  doc.text(
    "Нийт дүн:",
    PAGE_WIDTH - 52 - leftX,
    currentY + offsetY + lineHeight
  );
  doc.text(
    `${formatCurrency((totalPrice ?? 0) + (totalPriceCollective ?? 0))}`,
    PAGE_WIDTH - 20.5 - leftX,
    currentY + offsetY + lineHeight
  );

  currentY += offsetY + lineHeight;

  doc.text("Танд Баярлалаа!", PAGE_HALF_WIDTH, currentY + lineHeight * 2, {
    align: "center",
  });

  currentY += lineHeight * 3;
  doc.setLineDashPattern([1, 0.4]);
  doc.line(leftX, currentY, PAGE_WIDTH - leftX, currentY);

  if (doc.lastAutoTable.finalY > 145 && doc.lastAutoTable.finalY < 181) {
    doc.addPage();
    currentY = 10;
  }

  currentY += lineHeight + offsetY;

  doc.setFontSize(8);
  COLUMN_GAP = 4;
  const imgQR = new Image();
  imgQR.src = qrBase64;
  doc.addImage(imgQR, "base64", leftX, currentY - 2, 20, 20);

  doc.setFont("Times-New-Roman");
  txt = "Хүлээн авагчийн нэр";
  doc.text(txt, leftX + 20 + COLUMN_GAP, currentY);
  currentX += doc.getTextWidth(txt);
  doc.setFont("Times-New-Roman-Bold");
  doc.text(wrappedText, leftX + 20 + COLUMN_GAP, currentY + lineHeight);

  doc.setFont("Times-New-Roman");
  doc.text(
    "Утас",
    leftX + 20 + COLUMN_GAP,
    currentY + lineHeight * 2 + offsetY + 2
  );
  doc.setFont("Times-New-Roman-Bold");
  doc.text(
    data?.customerPhone || "-",
    leftX + 20 + COLUMN_GAP,
    currentY + lineHeight * 3 + offsetY + 2
  );

  if (data.isReplace) {
    doc.setFont("Times-New-Roman");
    doc.text(
      "Буцаалтын захиалга",
      leftX + 20 + COLUMN_GAP,
      currentY + lineHeight * 4 + offsetY
    );
    doc.setFont("Times-New-Roman-Bold");
    doc.text(
      data?.replaceOrder || "-",
      leftX + 20 + COLUMN_GAP,
      currentY + lineHeight * 5 + offsetY
    );
  }

  currentX = leftX + 20 + COLUMN_GAP + doc.getTextWidth(txt);

  doc.setFont("Times-New-Roman");
  txt = "Захиалгын дугаар";
  doc.text(txt, currentX + COLUMN_GAP, currentY);
  doc.setFont("Times-New-Roman-Bold");
  doc.text(data?.code || "-", currentX + COLUMN_GAP, currentY + lineHeight);

  doc.setFont("Times-New-Roman");
  doc.text(
    "Захиалсан",
    currentX + COLUMN_GAP,
    currentY + lineHeight * 2 + offsetY + 2
  );
  doc.setFont("Times-New-Roman-Bold");
  doc.text(
    doc.splitTextToSize(
      data?.createdAt ? getDateTime(data.createdAt) : "-",
      25
    ),
    currentX + COLUMN_GAP,
    currentY + lineHeight * 3 + offsetY + 2
  );

  currentX += COLUMN_GAP + doc.getTextWidth(txt);
  doc.setFont("Times-New-Roman");
  doc.text("Дүүрэг", currentX + COLUMN_GAP, currentY);
  doc.setFont("Times-New-Roman-Bold");
  txt =
    data?.dropoffAddressArray?.length > 2
      ? `${data.dropoffAddressArray[0]?.name}, ${data.dropoffAddressArray[1]?.name}`
      : "-";
  doc.text(
    doc.splitTextToSize(txt, 25),
    currentX + COLUMN_GAP,
    currentY + lineHeight
  );
  doc.addImage(
    img,
    "png",
    PAGE_WIDTH - leftX - 20,
    currentY - 2,
    20,
    5.12,
    "FAST"
  );

  doc.setFont("Times-New-Roman");
  doc.text(
    "Хороо/Баг",
    currentX + COLUMN_GAP,
    currentY + lineHeight * 2 + offsetY + 2
  );
  doc.setFont("Times-New-Roman-Bold");
  txt =
    data?.dropoffAddressArray?.length > 2
      ? `${data.dropoffAddressArray[2]?.name}`
      : "-";
  doc.text(txt, currentX + COLUMN_GAP, currentY + lineHeight * 3 + offsetY + 2);

  doc.setFont("Times-New-Roman");
  doc.text(
    "Хаяг",
    currentX + COLUMN_GAP,
    currentY + lineHeight * 4 + offsetY + 2
  );
  doc.setFont("Times-New-Roman-Bold");
  doc.text(
    doc.splitTextToSize(data?.dropoffDetail || "-", 40),
    currentX + COLUMN_GAP,
    currentY + lineHeight * 5 + offsetY + 2
  );
};
